import React from 'react'
import PropTypes from 'prop-types'
import NRTRadioGroup from "../../../../../_common/_form/FormInput/RadioGroup"
import NRTCheckboxInput from "../../../../../_common/_form/FormInput/CheckboxInput"
import NRTFormInput from "../../../../../_common/_form/FormInput"
import {Validators} from "../../../../../_common/_form/Validators"

//import './style.css'

const NRTQuestionText = (props) => {
    return (
        <div>

            <NRTFormInput
                name={props.code}
                value={props.answer}
                type={'textarea'}
                disabled={props.disabled}
                validators={[
                    Validators.required()
                ]}
            />

        </div>
    )
}

NRTQuestionText.propTypes = {
    id: PropTypes.string.isRequired ,
}

NRTQuestionText.defaultProps = {}

export default NRTQuestionText



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/Questions/_components/Text/index.js